'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _modal = require('./modal.scss');

var _modal2 = _interopRequireDefault(_modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Modal = function (_React$Component) {
    _inherits(Modal, _React$Component);

    function Modal(props) {
        _classCallCheck(this, Modal);

        return _possibleConstructorReturn(this, (Modal.__proto__ || Object.getPrototypeOf(Modal)).call(this, props));
    }

    _createClass(Modal, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            this.modal = document.createElement('div');
            document.body.appendChild(this.modal);
            this.renderLayer();

            if (this.props.escClose) {
                document.addEventListener('keyup', function (e) {
                    if (e.code === 'Escape') {
                        e.preventDefault();
                        _this2.props.closeHandler(e);
                    }
                });
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            _reactDom2.default.unmountComponentAtNode(this.modal);
            document.body.removeChild(this.modal);
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            this.renderLayer();

            if (this.props.isOpen) {
                document.documentElement.classList.add('modal-is-open');
            } else {
                document.documentElement.classList.remove('modal-is-open');
            }
        }
    }, {
        key: 'renderLayer',
        value: function renderLayer() {
            _reactDom2.default.render(_react2.default.createElement(
                'div',
                { id: this.props.id, className: _modal2.default.modal + (this.props.isOpen ? ' ' + _modal2.default["is-open"] : '') },
                _react2.default.createElement('div', { className: _modal2.default.background, onClick: this.props.backgroundClickClose ? this.props.closeHandler : null }),
                _react2.default.createElement(
                    'div',
                    { className: _modal2.default.content },
                    this.props.children
                )
            ), this.modal);
        }
    }, {
        key: 'render',
        value: function render() {

            // Render a placeholder
            // Styles below are added this way, so they'll be exported.
            // Haven't found a better way yet.
            return _react2.default.createElement('div', {
                className: _modal2.default.modal + ' ' + _modal2.default.background + ' ' + _modal2.default.content + ' ' + _modal2.default["is-open"],
                style: { display: 'none' }
            });
        }
    }]);

    return Modal;
}(_react2.default.Component);

Modal.defaultProps = {
    closeHandler: function closeHandler() {},
    escClose: false,
    backgroundClickClose: false
};

exports.default = Modal;


//////////////////
// WEBPACK FOOTER
// ./client/components/modal/index.js
// module id = 183
// module chunks = 0